export interface ContactLead {
  firstName: string;
  lastName: string;
  email: string;
  companyName: string;
  companySize: string;
  jobTitle?: string | null;
  message?: string | null;
}

export const CompanySizeOptions: Record<string, string> = {
  '1 to 10': 'up to 10',
  'Less than 500': 'up to 500',
  '500 to 1,000': 'up to 1,000',
  '1,000 to 2,500': 'up to 2,500',
  '2,500 or more': '2,500 or more',
};
